import React, { Component, Fragment } from 'react';

import  {
    FormHelperText,
    Grid,
} from '@mui/material';

import Currency from '../../common/Currency';
import InputText from '../../common/Form';


class PaymentLineSingleFullAdvance extends Component {
    state = {
        acompte: 0,
        supplier: {}
    }
    componentDidMount = () => {
        console.log('=================CDM===================');
        console.log();
        console.log('====================================');
        const { SUPPLIERS, spending } = this.props;
        if (spending && SUPPLIERS[spending.spending_supplier] && (SUPPLIERS[spending.spending_supplier].supplier_account > 0)) {
            let acompte = SUPPLIERS[spending.spending_supplier].supplier_account
            this.setState({
                acompte,
                supplier: SUPPLIERS[spending.spending_supplier]
            })
            let rest = (this.props.payment_amount - acompte > 0) ? this.props.payment_amount - acompte : 0
            this.props.handleChange("payment_amount", parseFloat(rest) , this.props.index)
        }
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        const regex = /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/

        if(name === "payment_amount" || name === "payment_advance_amount"){
            if(regex.test(value) || value === ""){
                this.props.handleChange(name, parseFloat(value) , this.props.index)
            }
        } else {
            this.props.handleChange(name, value , this.props.index)
        }
    }
    handleChangeCreatable = (option, name) => {
        this.props.handleChangeCreatable(option, name, this.props.index)
    }
    // deleteLine = (e) => {
    //     this.props.deleteLine(this.props.index)
    // }

    render() {
        const { index, spending, errors } = this.props;
        const { acompte, supplier } = this.state;
        let background = (index % 2 === 0) ? "" : "#f1f4f7";
        console.log('====================================');
        console.log({spending});
        console.log('====================================');
        return (
            <div>
                <hr/>
                <div style={{background, padding: "15px", marginBottom: "15px" }}>
                    <h6>Dépense </h6>
                     
                    <Grid container spacing={2}>
                        <Grid item sm={9} xs={11}>
                            <InputText
                                required
                                error={errors.payment_spending_id}
                                label="Dépense"
                                // onChange={(option) => this.handleChangeCreatable(option, "payment_spending_id")}
                                name="payment_spending_id" 
                                id="payment_spending_id"
                                value={this.props.payment_spending_idDisplay.label}
                            />
                        </Grid>
                        <Grid item sm={3} xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="payment_advance_amount"
                                error={errors.payment_advance_amount}
                                value={this.props.payment_advance_amount}
                                name="payment_advance_amount"
                                label="Acompte"
                                type="number"                              
                            />
                            <FormHelperText >Acompte total : {acompte}</FormHelperText>
                            <FormHelperText >Reste à Payer : <Currency value={spending.spending_rest_to_pay}/></FormHelperText>
                        </Grid>
                        {/* <Grid item sm={3} xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="payment_amount"
                                error={errors.payment_amount}
                                value={this.props.payment_amount}
                                name="payment_amount"
                                label="Montant"
                                type="number"                              
                            />
                            {!isEmpty(spending) && 
                                <FormHelperText >Reste à Payer : <Currency value={spending.spending_rest_to_pay}/></FormHelperText>
                            }
                        </Grid> */}
                    </Grid>
                </div>                
            </div>
        );
    }
}


export default PaymentLineSingleFullAdvance 